import React from 'react';
import styles from './Input.module.sass';

import currency from '../../../utils/currency';

import CurrencyInput from './CurrencyInput/CurrencyInput';
import DropdownInput from "./DropdownInput/DropdownInput";
import RadioInput from "./RadioInput/RadioInput";
import InputForm from "../Form/Input/Input";
import AutocompleteInput from "./AutocompleteInput/AutocompleteInput";

const input = (props) => {
    switch (props.type) {
        case inputType.CURRENCY: {
            const isValid = props.value === "" || currency.currencyToNumber(props.value) === 0 || props.valid;
            return (
                <div className="Input">
                    <CurrencyInput {...props} valid={isValid}/>
                    {
                        isValid ? null : <label className={styles.Error}>{props.error}</label>
                    }
                </div>
            );
        }
        case inputType.DROPDOWN: {
            return <DropdownInput  {...props}/>
        }
        case inputType.AUTOCOMPLETE: {
            return <AutocompleteInput  {...props}/>
        }
        case inputType.RADIO: {
            return <RadioInput  {...props}/>
        }
        default: {
            return <InputForm {...props}/>;
        }
    }
};

export const inputType = {
    CURRENCY: 'currency',
    DROPDOWN: 'dropdown',
    RADIO: 'radio',
    AUTOCOMPLETE: 'autocomplete'
};

export default input;
